module.exports = __webpack_public_path__ + "img/app3.8b56c84.png";